module.exports = __webpack_public_path__ + "static/media/Resume Plus.dc60cd0c.pdf";